//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SfButton, SfIcon, SfLink } from '@storefront-ui/vue';

export default {
  name: 'KESfPagination',
  components: {
    SfIcon,
    SfLink,
    SfButton
  },
  props: {
    total: {
      type: Number,
      default: 0
    },
    visible: {
      type: Number,
      default: 5
    },
    hasArrows: {
      type: Boolean,
      default: true
    },
    current: {
      type: Number,
      default: 1
    },
    pageParamName: {
      type: String,
      default: 'page'
    },
    baseUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasRouter() {
      return false;
    },
    componentIs() {
      return this.hasRouter ? 'SfLink' : 'AtomsKEButton';
    },
    currentPage() {
      return this.hasRouter
        ? this.$route.query[this.pageParamName]
          ? parseInt(this.$route.query[this.pageParamName], 10)
          : 1
        : this.current;
    },
    getPrev() {
      return this.currentPage === this.firstVisiblePageNumber
        ? this.currentPage
        : this.currentPage - 1;
    },
    canGoPrev() {
      return this.currentPage !== this.firstVisiblePageNumber;
    },
    getNext() {
      return this.currentPage === this.lastVisiblePageNumber
        ? this.currentPage
        : this.currentPage + 1;
    },
    canGoNext() {
      return this.currentPage !== this.lastVisiblePageNumber;
    },
    showFirst() {
      return this.firstVisiblePageNumber > 1;
    },
    showLast() {
      return this.lastVisiblePageNumber < this.total;
    },
    listOfPageNumbers() {
      return Array.from(Array(this.total), (_, i) => i + 1);
    },
    limitedPageNumbers() {
      if (this.total <= this.visible) {
        return this.listOfPageNumbers;
      }
      if (this.currentPage < this.visible - Math.floor(this.visible / 2) + 1) {
        return this.listOfPageNumbers.slice(0, this.visible);
      }
      if (
        this.total - this.currentPage <
        this.visible - Math.ceil(this.visible / 2) + 1
      ) {
        return this.listOfPageNumbers.slice(this.total - this.visible);
      }
      return this.listOfPageNumbers.slice(
        this.currentPage - Math.ceil(this.visible / 2),
        this.currentPage + Math.floor(this.visible / 2)
      );
    },
    firstVisiblePageNumber() {
      return this.limitedPageNumbers[0];
    },
    lastVisiblePageNumber() {
      return this.limitedPageNumbers[this.limitedPageNumbers.length - 1];
    }
  },
  methods: {
    go(page) {
      this.$emit('click', page);
    },
    getLinkTo(page) {
      const pageNumber = page.toString();
      if (this.hasRouter) {
        return {
          ...this.$route,
          query: { ...this.$route.query, [this.pageParamName]: page }
        };
      } else {
        return pageNumber;
      }
    },
    getLinkHref(page) {
      // Generate SEO-friendly href with only the page parameter
      if (this.baseUrl) {
        // If baseUrl is provided, construct URL with only page param
        const separator = this.baseUrl.includes('?') ? '&' : '?';
        return `${this.baseUrl}${separator}${this.pageParamName}=${page}`;
      } else if (typeof window !== 'undefined') {
        const pathname = window.location.pathname;
        return `${pathname}?${this.pageParamName}=${page}`;
      } else {
        return `?${this.pageParamName}=${page}`;
      }
    },
    handleClick(event, page) {
      event.preventDefault();

      if (this.currentPage === page) {
        return;
      }

      this.go(page);
    }
  }
};
